import React from 'react';
import { Home, Key } from 'lucide-react';
import { formatCurrency, formatDuration } from '../../../../utils/formatters';
import { Card, CardHeader, CardTitle, CardContent } from '../../../../components/ui/Card';
import DefinitionItem from './DefinitionItem';

export default function RealEstateOverview({ transaction }) {
  return (
    <div className="space-y-6">
      <Card className="shadow-hp-sm">
        <CardHeader className="flex flex-row items-center gap-3 border-b border-[var(--hp-color-border-muted)] px-5 py-4">
          <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-surface-muted text-primary">
            <Key className="h-4.5 w-4.5" />
          </div>
          <div>
            <CardTitle className="text-base font-semibold text-primary">Structure de l'opération</CardTitle>
            <p className="mt-0.5 text-sm text-subtle">Détails du portage immobilier et faculté de rachat.</p>
          </div>
        </CardHeader>

        <CardContent className="p-5">
          <dl className="grid grid-cols-1 gap-x-6 gap-y-5 sm:grid-cols-2 lg:grid-cols-3">
            <DefinitionItem
              label="Prix d'acquisition (Décoté)"
              value={formatCurrency(transaction.targetAmount, transaction.currency)}
              emphasis
            />
            <DefinitionItem
              label="Prix de rachat"
              value={null}
            />
            <DefinitionItem
              label="Durée du portage (Max)"
              value={formatDuration(transaction.durationMonths)}
            />
            <DefinitionItem
              label="Indemnité d'occupation mensuelle"
              value={null}
            />
          </dl>
        </CardContent>
      </Card>

      <Card className="shadow-hp-sm">
        <CardHeader className="flex flex-row items-center gap-3 border-b border-[var(--hp-color-border-muted)] px-5 py-4">
          <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-surface-muted text-primary">
            <Home className="h-4.5 w-4.5" />
          </div>
          <div>
            <CardTitle className="text-base font-semibold text-primary">Actif immobilier</CardTitle>
            <p className="mt-0.5 text-sm text-subtle">Caractéristiques du bien faisant l'objet de la transaction.</p>
          </div>
        </CardHeader>

        <CardContent className="p-5">
          <dl className="grid grid-cols-1 gap-x-6 gap-y-5 sm:grid-cols-2 lg:grid-cols-3">
            <DefinitionItem
              label="Valeur estimée de l'actif"
              value={null}
            />
            <DefinitionItem
              label="Décote"
              value={null}
            />
            <DefinitionItem
              label="Type d'actif"
              value={null}
            />
            <DefinitionItem
              label="Surface"
              value={null}
            />
            <DefinitionItem
              label="Adresse"
              value={null}
            />
            <DefinitionItem
              label="Rang hypothécaire"
              value={null}
            />
          </dl>
        </CardContent>
      </Card>
    </div>
  );
}
